import React from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../../DAL/store";
import {HidePluginView, SortItems} from "../../services/logic-helper";
import {ProductModel} from "../../interfaces";
import {PluginMobile} from "./plugin-mobile";
import SearchIcon from "../../../../ui/svg/common/search";
import {PluginsSortOptions} from "./plugins-sort-options";
import {PluginViewMobile} from "./plugin-view-mobile";

interface IPluginsPopupMobileProps {

}
export const PluginsPopupMobile = (props: IPluginsPopupMobileProps) => {

    const PageData = useAppSelector((store) => store.PageData);
    const SearchFilterKey = useAppSelector((store) => store.SearchFilterKey);
    const PluginSortStatus = useAppSelector((store) => store.PluginSortStatus);
    const ShowPluginImageSortIncludesID = useAppSelector((store) => store.ShowPluginImageSortIncludesID);
    const PlanOnMobilePluginsPopup = useAppSelector((store) => store.PlanOnMobilePluginsPopup);

    const dispatch = useAppDispatch();

    const FilteredItems = PageData.products.filter(item => {
        let searchFilter = item.documentName.toLowerCase().includes(SearchFilterKey.toLowerCase());
        let planFilter = (PlanOnMobilePluginsPopup?.tierLowHigh === "low" && item.isLow === 1) || (PlanOnMobilePluginsPopup?.tierLowHigh === "high" && item.isHigh === 1);
        return  searchFilter && planFilter;
    });
    const SortedAndFilteredItems = SortItems(FilteredItems,PluginSortStatus);

    return (
          <div className="w-full text-white">
              <div className="relative p-1 mb-2" style={{height:"170px"}}>

                  <div className="w-full pt-3 text-xl">{PlanOnMobilePluginsPopup !== null ? PlanOnMobilePluginsPopup.tierName : ""}</div>

                  <div className="w-full overflow-hidden py-1 outline-none bg-dark-input rounded-full flex items-center mt-8 search-plugins-input-container" >
                      <SearchIcon classes={"ml-3 mr-2"} width={"15px"} color={"white"} />

                      <input
                          className="flex-1 text-sm font-normal text-white bg-dark-input outline-none"
                          aria-label={ "filterPlaceholderText" }
                          value={ SearchFilterKey }
                          autoComplete="off"
                          type="text"
                          placeholder={ "Search plugins" }
                          onChange={ evt => {
                              dispatch(
                                  rootActions.main({
                                      SearchFilterKey:evt.target.value.trim()
                                  })
                              )
                          }}
                          style={{
                              textIndent: '10px'
                          }}
                      ></input>
                  </div>
                  <PluginsSortOptions />

              </div>
              <ul className="w-full popup-plugins-items py-4 " id="plugins-list-container" onClick={() => HidePluginView(dispatch)}  style={{height:"72vh"}}>
                  {SortedAndFilteredItems.length > 0 && SortedAndFilteredItems.map((product : ProductModel, index: number) => {
                      return <PluginMobile key={index} product={product} index={index}  />
                  })}
              </ul>
              {ShowPluginImageSortIncludesID > 0 &&
                  <PluginViewMobile product={SortedAndFilteredItems.filter(product => product.sortIncludes === ShowPluginImageSortIncludesID )[0]}  />
              }
          </div>
    )
};